import { Component, OnInit, Input } from "@angular/core";
import { ModalController } from "@ionic/angular";
import { InventoryService } from "../../../api/inventory.service";
import { AppSettings } from "src/app/app-settings";

@Component({
  selector: "app-inventory-item",
  templateUrl: "./inventory-item.page.html",
  styleUrls: ["./inventory-item.page.scss"],
})
export class InventoryItemPage {
  @Input() inventoryItemId: number = null;
  private loading: boolean;

  public reference: string;
  public quantity: number;
  public price: number;
  public manufacturer: string;
  public condition: string;
  public description: string;

  isWeb = AppSettings.IS_WEB;

  constructor(
    private modalCtrl: ModalController,
    private inventoryService: InventoryService
  ) {}

  ngOnInit() {}

  ionViewWillEnter() {
    if (!this.inventoryItemId) return;

    this.loading = true;

    this.inventoryService
      .get(this.inventoryItemId)
      .then((response) => {
        this.reference = response["part_number"];
        this.quantity = response["quantity"];
        this.price = response["price"];
        this.manufacturer = response["manufacturer"];
        this.condition = response["condition"];
        this.description = response["description"];
        this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
      });
  }

  closeInventoryItemModal() {
    this.modalCtrl.dismiss(null);
  }
}
